import {availableStates} from '@/helpers/availableStates'
import getApiClient from '@/plugins/api'
import BankInput from '../BankInput/Index.vue'

export default {
  name: 'PagarmeRecipient',
  components: {
    BankInput,
  },
  data: function () {
    return {
      errors: {},
      availableStates,
      showRecipientError: false,
      recipientErrors: {},
      refusedRecipient: false,
      recipientTypes: [
        {
          label: 'Pessoa física',
          value: 'individual'
        },
        {
          label: 'Pessoa jurídica',
          value: 'corporation'
        }
      ],
      bankAccountTypes: [
        {
          label: 'Conta corrente',
          value: 'checking'
        },
        {
          label: 'Poupança',
          value: 'savings'
        }
      ],
      bankAccountHolderTypes: [
        {
          label: 'Pessoa física',
          value: 'individual'
        },
        {
          label: 'Pessoa jurídica',
          value: 'company'
        }
      ],
      availableTransferIntervals: [
        {
          label: 'Diariamente',
          value: 'Daily'
        },
        {
          label: 'Semanalmente',
          value: 'Weekly'
        },
        {
          label: 'Mensalmente',
          value: 'Monthly'
        }
      ],
      currentStep: 1,
      pagarmeRecipient: {
        code: null,
        registerInformation: {
          name: null,
          type: 'individual',
          email: null,
          document: null,
          birthdate: null,
          monthly_income: 0,
          professional_occupation: null,
          address: {
            street: null,
            street_number: null,
            complementary: null,
            reference_point: null,
            zip_code: null,
            neighborhood: null,
            city: null,
            state: null,
          },
          phone_numbers: [],
          company_name: null,
          trading_name: null,
          annual_revenue: null,
          corporation_type: 'LTDA',
          founding_date: null,
          main_address: {
            street: null,
            street_number: null,
            complementary: null,
            reference_point: null,
            zip_code: null,
            neighborhood: null,
            city: null,
            state: null,
          },
          managing_partners: [
            {
              self_declared_legal_representative: true,
            },
          ],
        },
        defaultBankAccount: {
          holder_name: null,
          holder_type: 'individual',
          holder_document: null,
          bank: null,
          branch_number: null,
          account_number: null,
          account_check_digit: null,
          type: 'checking',
        },
        transferSettings: {
          transfer_enabled: true,
          transfer_interval: 'daily',
          transfer_day: 0,
        },
        automaticAnticipationSettings: {
          enabled: true,
          volume_percentage: 100
        }
      },
    }
  },
  computed: {
    hasErrors() {
      return Object.keys(this.errors).length > 0
    },
  },
  methods: {
    loadAddress(prop) {
      const url = `https://viacep.com.br/ws/${prop.zip_code}/json/`,
        self = this

      if (prop.zip_code?.length < 9) {
        return
      }

      self.$store.commit('startLoading')
      fetch(url)
        .then(result => {
          result.json().then((data) => {
            prop.street = data.logradouro
            prop.neighborhood = data.bairro
            prop.city = data.localidade
            prop.state = data.uf
          }).catch(() => {})
        }).catch(() => {})
        .finally(() => {
          self.$store.commit('stopLoading')
        })
    },
    processValidationErrors(errors) {
      const self = this
      if (errors.violations) {
        errors.violations.forEach((violation) => {
          self.errors[violation.propertyPath] = violation.message
        })

        self.error = true
      }
    },

    setTransferEnabled(event) {
      this.pagarmeRecipient.transferSettings.transfer_enabled = event.target.checked
    },

    setAutomaticAnticipationEnabled(event) {
      this.pagarmeRecipient.automaticAnticipationSettings.enabled = event.target.checked
    },

    savePagarmeRecipient() {
      const self = this,
        api = getApiClient(self.$store)

      const steps = self.pagarmeRecipient.registerInformation.type === 'corporation'
        ? [1, 2, 3, 4]
        : [1, 3, 4]

      for (const step of steps) {
        if (!self.validateStep(step)) {
          self.currentStep = step
          return
        }
      }

      self.$store.commit('startLoading')
      self.error = false
      self.success = false

      if (self.beforeSubmit) {
        self.beforeSubmit()
      }

      let method = 'post',
        endpoint = 'pagarme_recipients'

      if (self.pagarmeRecipient.id && !self.refusedRecipient) {
        method = 'put'
        endpoint = `pagarme_recipients/${self.pagarmeRecipient.id}`
      }

      if (!self.pagarmeRecipient.code) {
        self.pagarmeRecipient.code = Math.floor(10000000000000 + Math.random() * 90000000000000).toString()
      }

      self.pagarmeRecipient.registerInformation.phone_numbers = [
        {
          type: 'cellphone',
          ddd: self.agency.phone.slice(0, 2),
          number: self.agency.phone.slice(2, self.agency.phone.length)
        }
      ]
      const payload = JSON.parse(JSON.stringify(self.pagarmeRecipient))
      payload.agencyId = self.agency.id

      if (payload['@id']) {
        delete payload['@id']
      }

      if (payload.registerInformation?.document) {
        payload.registerInformation.document = payload.registerInformation.document.replace(/[^\d]+/g, '')
      }

      if (payload.defaultBankAccount?.holder_document) {
        payload.defaultBankAccount.holder_document = payload.defaultBankAccount.holder_document.replace(/[^\d]+/g, '')
      }

      if (payload.registerInformation?.managing_partners && payload.registerInformation?.managing_partners[0]?.document) {
        payload.registerInformation.managing_partners[0].document = payload.registerInformation.managing_partners[0].document.replace(/[^\d]+/g, '')
      }

      payload.registerInformation.main_address = payload.registerInformation.address

      if (payload.registerInformation?.type === 'corporation') {
        payload.registerInformation.managing_partners[0].address = payload.registerInformation.main_address
        payload.registerInformation.managing_partners[0].phone_numbers = payload.registerInformation.phone_numbers
        payload.registerInformation.managing_partners[0].self_declared_legal_representative = true
      } else {
        if (payload.registerInformation?.managing_partners) {
          delete payload.registerInformation.managing_partners
        }
      }

      api[method](endpoint, payload)
        .then((result) => {
          self.agency.pagarmeId = result.data.id
          self.pagarmeRecipient.id = result.data.id
          if (self.onSuccess) {
            self.onSuccess()
          }
          self.success = true
          self.currentStep = 1
        })
        .catch(error => {
          if (error.response) {
            switch (error.response.status) {
              case 400:
              case 422:
                self.processValidationErrors(error.response.data)
                self.showRecipientError = true
                self.recipientErrors = error.response.data
                break;
              case 500:
                self.error = true
                break;
            }
          }
        })
        .finally(() => {
          self.$store.commit('stopLoading')
        })
    },

    isValidEmail(value) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value ?? '').trim())
    },

    onlyDigits(value) {
      return String(value ?? '').replace(/[^\d]+/g, '')
    },

    validateStep(step) {
      const errors = {}
      const ri = this.pagarmeRecipient.registerInformation
      const ba = this.pagarmeRecipient.defaultBankAccount
      const addr = ri.address

      const requireText = (obj, key, field, label) => {
        const raw = obj[key]
        if (raw === null || raw === undefined || String(raw).trim() === '') {
          errors[field] = `${label} é obrigatório.`
          return false
        }
        obj[key] = String(raw).trim()
        return true
      }

      const requireSelected = (value, field, label) => {
        if (value === null || value === undefined || value === '') {
          errors[field] = `${label} é obrigatório.`
          return false
        }
        return true
      }

      const requireCurrency = (value, field, label) => {
        if (value === null || value === undefined || value === '' || Number(value) <= 0) {
          errors[field] = `${label} é obrigatório.`
          return false
        }
        return true
      }

      const requireEmail = (obj, key, field, label) => {
        if (!requireText(obj, key, field, label)) {
          return false
        }
        if (!this.isValidEmail(obj[key])) {
          errors[field] = `Informe um ${label.toLowerCase()} válido.`
          return false
        }
        return true
      }

      const requireDate = (obj, key, field, label, minAge) => {
        if (!requireText(obj, key, field, label)) {
          return false
        }
        const date = this.$moment(obj[key], 'DD/MM/YYYY', true)
        if (!date.isValid()) {
          errors[field] = `Informe uma ${label.toLowerCase()} válida.`
          return false
        }
        if (minAge && this.$moment().diff(date, 'years') < minAge) {
          errors[field] = `É necessário ter pelo menos ${minAge} anos.`
          return false
        }
        return true
      }

      switch (step) {
        case 1:
          requireText(ri, 'name', 'name', 'Nome')
          requireSelected(ri.type, 'type', 'Tipo')
          requireText(ri, 'document', 'document', 'Documento')
          requireEmail(ri, 'email', 'email', 'E-mail')
          requireDate(ri, 'birthdate', 'birthdate', 'Data de nascimento', 18)
          requireCurrency(ri.monthly_income, 'monthly_income', 'Renda mensal')
          requireText(ri, 'professional_occupation', 'professional_occupation', 'Ocupação')
          break
        case 2:
          // "Dados da empresa" is only required for corporations.
          if (ri.type === 'corporation') {
            const partner = (ri.managing_partners && ri.managing_partners[0]) || {}
            requireText(ri, 'company_name', 'company_name', 'Nome fantasia')
            requireText(ri, 'trading_name', 'trading_name', 'Razão social')
            requireCurrency(ri.annual_revenue, 'annual_revenue', 'Receita anual')
            requireDate(ri, 'founding_date', 'founding_date', 'Data de fundação')
            requireText(ri, 'corporation_type', 'corporation_type', 'Tipo de empresa')
            requireText(partner, 'name', 'partner_name', 'Nome do representante')
            requireText(partner, 'document', 'partner_document', 'Documento do representante')
            requireEmail(partner, 'email', 'partner_email', 'E-mail do representante')
            requireDate(partner, 'birthdate', 'partner_birthdate', 'Data de nascimento do representante', 18)
            requireCurrency(partner.monthly_income, 'partner_monthly_income', 'Renda mensal do representante')
            requireText(partner, 'professional_occupation', 'partner_professional_occupation', 'Ocupação do representante')
            requireText(partner, 'mother_name', 'partner_mother_name', 'Nome da mãe do representante')
          }
          break
        case 3:
          if (requireText(ba, 'holder_name', 'holder_name', 'Nome do titular da conta') &&
            ba.holder_name !== String(ri.name ?? '').trim()) {
            errors.holder_name = 'O nome do titular deve ser igual ao nome informado nos dados básicos.'
          }
          requireSelected(ba.holder_type, 'holder_type', 'Tipo')
          if (requireText(ba, 'holder_document', 'holder_document', 'Documento do titular da conta') &&
            this.onlyDigits(ba.holder_document) !== this.onlyDigits(ri.document)) {
            errors.holder_document = 'O documento do titular deve ser igual ao documento informado nos dados básicos.'
          }
          requireSelected(ba.bank, 'bank', 'Banco')
          requireText(ba, 'branch_number', 'branch_number', 'Agência')
          requireText(ba, 'account_number', 'account_number', 'Número da conta')
          requireText(ba, 'account_check_digit', 'account_check_digit', 'Dígito verificador')
          requireSelected(ba.type, 'account_type', 'Tipo de conta')
          break
        case 4:
          requireText(addr, 'zip_code', 'zip_code', 'CEP')
          requireText(addr, 'street', 'street', 'Rua')
          requireText(addr, 'street_number', 'street_number', 'Número')
          requireText(addr, 'neighborhood', 'neighborhood', 'Bairro')
          requireText(addr, 'complementary', 'complementary', 'Complemento')
          requireText(addr, 'city', 'city', 'Cidade')
          requireSelected(addr.state, 'state', 'Estado')
          requireText(addr, 'reference_point', 'reference_point', 'Ponto de referência')
          break
        default:
          break
      }

      this.errors = errors
      return Object.keys(errors).length === 0
    },

    nextStep() {
      if (!this.validateStep(this.currentStep)) {
        return
      }

      if (this.currentStep === 1) {
        if (!this.pagarmeRecipient?.defaultBankAccount?.holder_document) {
          this.pagarmeRecipient.defaultBankAccount.holder_document = this.pagarmeRecipient.registerInformation.document
        }

        if (this.pagarmeRecipient.registerInformation.type === 'corporation') {
          if (!this.pagarmeRecipient?.registerInformation?.managing_partners) {
            this.pagarmeRecipient.registerInformation.managing_partners = [
              {
                self_declared_legal_representative: true,
              }
            ]
          }

          const partner = this.pagarmeRecipient.registerInformation.managing_partners[0]
          if (!partner.name) {
            partner.name = this.pagarmeRecipient.registerInformation.name
          }
          if (!partner.birthdate) {
            partner.birthdate = this.pagarmeRecipient.registerInformation.birthdate
          }
          if (!partner.document) {
            partner.document = this.pagarmeRecipient.registerInformation.document
          }
        }

        if (!this.pagarmeRecipient?.defaultBankAccount?.holder_name) {
          this.pagarmeRecipient.defaultBankAccount.holder_name = this.pagarmeRecipient.registerInformation.name
        }
      }

      if (this.currentStep === 1 && this.pagarmeRecipient.registerInformation.type !== 'corporation') {
        this.currentStep = 3
      } else {
        this.currentStep++
      }
    },

    prevStep() {
      this.errors = {}
      if (this.currentStep === 3 && this.pagarmeRecipient.registerInformation.type !== 'corporation') {
        this.currentStep = 1
      } else {
        this.currentStep--
      }
    },

    setRecipientType(value) {
      this.errors = {}
      this.pagarmeRecipient.registerInformation.type = value
      if (value === 'individual') {
        this.pagarmeRecipient.defaultBankAccount.holder_type = 'individual'
      } else if (value === 'corporation') {
        this.pagarmeRecipient.defaultBankAccount.holder_type = 'company'
      }
    },

    preloadData() {
      const self = this,
        api = getApiClient(self.$store)

      if (self.agency.pagarmeId) {
        self.$store.commit('startLoading')
        api.get(`/pagarme_recipients/${self.agency.pagarmeId}`)
          .then(response => {
            if (response.data.status === 'refused') {
              self.refusedRecipient = true
              return
            }
            if (!response.data.registerInformation.address && response.data.registerInformation.main_address) {
              response.data.registerInformation.address = response.data.registerInformation.main_address
            }

            if (!response.data.registerInformation.address) {
              response.data.registerInformation.address = {
                street: null,
                street_number: null,
                complementary: null,
                reference_point: null,
                zip_code: null,
                neighborhood: null,
                city: null,
                state: null,
              }
            }

            if (!response.data.managing_partners) {
              response.data.registerInformation.managing_partners = [{

              }]
            }

            if (!response.data.registerInformation.name && response.data.name) {
              response.data.registerInformation.name = response.data.name
            }

            if (response.data.registerInformation?.managing_partners) {
              if (!response.data.registerInformation.birthdate && response.data.registerInformation?.managing_partners[0]?.birthdate) {
                response.data.registerInformation.birthdate = response.data.registerInformation.managing_partners[0].birthdate
              }

              if (!response.data.registerInformation.monthly_income && response.data.registerInformation?.managing_partners[0]?.monthly_income) {
                response.data.registerInformation.monthly_income = response.data.registerInformation.managing_partners[0].monthly_income
              }

              if (!response.data.registerInformation.professional_occupation && response.data.registerInformation?.managing_partners[0]?.professional_occupation) {
                response.data.registerInformation.professional_occupation = response.data.registerInformation.managing_partners[0].professional_occupation
              }
            }

            self.pagarmeRecipient = response.data
          })
          .finally(() => {
            self.$store.commit('stopLoading')
          })
      }
    },
  },
  mounted() {
    this.preloadData()
  },
  props: {
    agency: Object,
    beforeSubmit: {
      type: Function,
      required: false,
    },
    onSuccess: {
      type: Function,
      required: false,
    },
  }
}
